import { useAlertController } from "../hooks/useAlertController";

export default function Notification() {
  useAlertController();
  return null;
}
